// 默认 页面 加载完成后会主动 发送 pageEnter 配置一些页面需要自定义处理
const NOT_AUTO_TO_LIST = [
  'page_pgc_article_detail', // 资讯详情
  'page_search_result_new', // 搜索
  'page_my_collection', // 收藏页面
  'page_personal_homepage', // 个人主页
  'page_feed_article_mix_static', // 资讯静态化
]

const cusPageEnter = (pageId: string) => {
  if (!pageId) {
    return false
  }
  return NOT_AUTO_TO_LIST?.includes(pageId)
}

export default cusPageEnter
